<button mat-icon-button
        [matMenuTriggerFor]="editMenu">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #editMenu="matMenu">
  <ng-template matMenuContent>
    <button mat-menu-item
            [routerLink]="transactionDetailsLink(tx)"
            [queryParams]="transactionDetailsQueryParams">
      <mat-icon>edit</mat-icon>
      <span>Edit</span>
    </button>
    <button *ngIf="canEditSubTransactions"
            mat-menu-item
            [routerLink]="transactionDetailsLinkAdmin(tx)"
            [queryParams]="transactionDetailsQueryParams">
      <mat-icon>border_color</mat-icon>
      <span>Admin edit</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item
            (click)="onExpandedDetailChanged()"
            *ngIf="!expandedDetail">
      <mat-icon>expand_more</mat-icon>
      <span>Expand</span>
    </button>
    <button mat-menu-item
            (click)="onExpandedDetailChanged()"
            *ngIf="expandedDetail">
      <mat-icon>expand_less</mat-icon>
      <span>Collapse</span>
    </button>
    <button mat-menu-item
            (click)="viewNewTab(tx)">
      <mat-icon>open_in_new</mat-icon>
      <span>Open In New</span>
    </button>
    <mat-divider></mat-divider>
    <button *ngIf="tx.type === TransactionType.Draw && tx.status === TransactionStatus.Pending"
            mat-menu-item
            (click)="updateDialog(TransactionStatus.Pending)">
      <mat-icon>help_outlined</mat-icon>
      <span>Add pending reason</span>
    </button>
    <button [ngClass]="CanUserMoveTransactionToStatusGrantedPermissions[TransactionStatus.Approved].hidden ? 'hide' : ''"
            mat-menu-item
            (click)="updateDialog(TransactionStatus.Approved)">
      <mat-icon>check</mat-icon>
      <span>Approve</span>
    </button>
    <button [ngClass]="CanUserMoveTransactionToStatusGrantedPermissions[TransactionStatus.OnHold].hidden ? 'hide' : ''"
            mat-menu-item
            (click)="updateDialog(TransactionStatus.OnHold)">
      <mat-icon>question_mark</mat-icon>
      <span>Hold</span>
    </button>
    <button [ngClass]="CanUserMoveTransactionToStatusGrantedPermissions[TransactionStatus.Rejected].hidden ? 'hide' : ''"
            mat-menu-item
            (click)="updateDialog(TransactionStatus.Rejected)">
      <mat-icon>block</mat-icon>
      <span>Reject</span>
    </button>
    <button [ngClass]="CanUserMoveTransactionToStatusGrantedPermissions[TransactionStatus.Declined].hidden ? 'hide' : ''"
            mat-menu-item
            (click)="updateDialog(TransactionStatus.Declined)">
      <mat-icon>warning</mat-icon>
      <span>Decline</span>
    </button>
    <button [ngClass]="CanUserMoveTransactionToStatusGrantedPermissions[TransactionStatus.Canceled].hidden ? 'hide' : ''"
            mat-menu-item
            (click)="updateDialog(TransactionStatus.Canceled)">
      <mat-icon>highlight_off</mat-icon>
      <span>Cancel</span>
    </button>
  </ng-template>
</mat-menu>
